import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=3b9930c2&scoped=true&"
import script from "./TextIcon.vue?vue&type=script&lang=js&"
export * from "./TextIcon.vue?vue&type=script&lang=js&"
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=3b9930c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9930c2",
  null
  
)

export default component.exports